const convertXMLtoString = xmlValue => {
  const htmlEl = document.createElement('span');
  htmlEl.textContent = xmlValue;

  return htmlEl.textContent;
};

export default convertXMLtoString;



// WEBPACK FOOTER //
// ./src/utils/convertXMLtoString.js